import React from "react"
import S from "./StyledMainTrackingSection"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCar, faMotorcycle } from "@fortawesome/free-solid-svg-icons"

const MainTrackingSection = () => {
  return (
    <S.TrackingWrapper>
      <div className="left-column">
        <S.TrackingTitle>
          Wykonywanie przeglądów okresowych budynków. Przeprowadzamy kontrolę
          stanu technicznego budynków:
        </S.TrackingTitle>
        <S.TrackingDescription>
          <ul>
            <li>
            użyteczności publicznej
            </li>
            <li>szpitale</li>
            <li>urzędy</li>
            <li>budynki mieszkalne</li>
            <li>obiekty przemysłowe i biurowe</li>
          </ul>
        </S.TrackingDescription>
      </div>
      <div className="right-column">
        <S.TrackingMap/>
      </div>
    </S.TrackingWrapper>
  )
}

export default MainTrackingSection
